






































import { Component } from 'vue-property-decorator';

import InternationalizationService from '@/api/InternationalizationService';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { OnboardingURL } from '@/views/Onboarding/helpers';
import GooglePreviewBusiness from '@/componentsV2/organisms/GooglePreviewBusiness/GooglePreviewBusiness.vue';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import APIService from '@/api';
import { Picture } from '@/components/atoms';

@Component({
  components: {
    FilledButton,
    Typography,
    GooglePreviewBusiness,
    Picture
  }
})
export default class YourStorePreview extends BusinessOnboardingModel {
  internationalizationService = new InternationalizationService();

  loading = false;

  data = {
    ...this.yourStoreDetailsFormData,
    ...this.yourStoreFormData,
    category: this.businessCategoryForm.selectedCategory
  };

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get businessCategoryForm() {
    return (
      this.$store.getters['businessOnboarding/getYourBusinessCategoryForm'] ||
      {}
    );
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get businessOnboardingState() {
    return this.$store.getters['businessOnboarding/getBusinessOnboardingState'];
  }

  get imageSrc() {
    return require(`@/assets/img/business-onboarding/business-preview/smile-face.png`);
  }

  goBack() {
    if (this.yourStoreDetailsFormData.completed) {
      this.$router.push(OnboardingURL.YOUR_BUSINESS_COMPLETE);
      return;
    }
    this.$router.push(OnboardingURL.YOUR_BUSINESS_ADDRESS);
  }

  onEdit() {
    this.$router.push(OnboardingURL.YOUR_BUSINESS_DETAIL);
  }

  async onSubmit() {
    try {
      this.loading = true;

      if (APIService.token) {
        await this.onCreateBusiness();
        this.finishOnboarding();
      } else {
        this.$router.push(OnboardingURL.USER_SIGN_UP);
      }
    } finally {
      this.loading = false;
    }
  }
}
